/** Result of the cold-boot startup catalog download orchestrator. */
export type StartupCatalogSyncOutcome =
  | { status: 'applied' }
  | { status: 'skipped_revision' }
  | { status: 'offline' }
  | { status: 'timeout'; timeoutMs: number }
  | { status: 'failed'; error: string }
  | { status: 'unavailable' }
  | { status: 'error'; message: string };

let lastStartupOutcome: StartupCatalogSyncOutcome | null = null;

/** Records the latest startup catalog sync outcome for post-login retry decisions. */
export function noteStartupCatalogSyncOutcome(outcome: StartupCatalogSyncOutcome | null): void {
  lastStartupOutcome = outcome;
}

/** @internal Tests */
export function getLastStartupCatalogSyncOutcome(): StartupCatalogSyncOutcome | null {
  return lastStartupOutcome;
}

/** @internal Tests */
export function clearStartupCatalogSyncOutcomeForTests(): void {
  lastStartupOutcome = null;
}

/** Whether a post-auth catalog download retry is worth attempting. */
export function shouldRetryCatalogDownloadAfterStartup(
  outcome: StartupCatalogSyncOutcome | null,
): outcome is StartupCatalogSyncOutcome {
  if (outcome == null) return false;
  switch (outcome.status) {
    case 'offline':
    case 'timeout':
      return true;
    case 'failed':
      return isCatalogDownloadRetryableFailure(outcome.error);
    case 'error':
      return isCatalogDownloadRetryableFailure(outcome.message);
    default:
      return false;
  }
}

function isCatalogDownloadRetryableFailure(error: string): boolean {
  if (/SYNC_DOWNLOAD|Falta configurar la descarga|base de datos local/i.test(error)) return false;
  return (
    /401|No autorizado|HTTP 401/i.test(error) ||
    /Fallo de conexión|Failed to fetch|TimeoutError/i.test(error) ||
    /HTTP 5\d{2}/.test(error) ||
    /HTTP 408/.test(error) ||
    /HTTP 429/.test(error)
  );
}
